import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {baseUrl,preUrl} from './network/baseUrl';
import moment from 'moment';

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.prototype.$preURl = preUrl;
// 导出文件流到文件
Vue.prototype.$downBlob = function (data, fileName) {
	function download(blobUrl) {
		const a = document.createElement("a");
		a.style.display = "none";
		a.download = fileName;
		a.href = blobUrl;
		a.click();
	}
	const blob = new Blob([data]);
	const blobUrl = window.URL.createObjectURL(blob);
	download(blobUrl);
};
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
